__turbopack_context__.v({
  "backdrop": "Modal-module__pjAAtG__backdrop",
  "body": "Modal-module__pjAAtG__body",
  "container": "Modal-module__pjAAtG__container",
  "dialogRoot": "Modal-module__pjAAtG__dialogRoot",
  "layer": "Modal-module__pjAAtG__layer",
  "root": "Modal-module__pjAAtG__root",
});
